/* ──────────────────────────────────────────────────────────────────────
   apiRecovery — cliente axios específico para o módulo de Recuperação.
   Usa SEMPRE baseURL relativa "/api" (mesma origin do navegador).
   Evita CORS quando o REACT_APP_BACKEND_URL aponta para outro domínio
   (ex.: bundle deployado em dnacore.novodna.com.br com env do preview).
   Preserva interceptor de Authorization igual ao client global.
   ────────────────────────────────────────────────────────────────────── */
import axios from 'axios';

const api = axios.create({
  baseURL: '/api', // ← rota relativa, mesma origin do frontend (sem CORS)
  timeout: 60000,
});

api.interceptors.request.use((config) => {
  const token = (typeof localStorage !== 'undefined') ? localStorage.getItem('token') : null;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.method === 'get') {
    config.params = { ...(config.params || {}), _t: Date.now() };
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      const isFamiliaRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/familia');
      if (!isFamiliaRoute) {
        try {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        } catch (_) { /* noop */ }
        if (typeof window !== 'undefined') window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
